(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify?.designMode) return;

  const overlay = document.getElementById('page-transition-overlay');
  if (!overlay) return;

  // ENTER: on new page, play reveal animation if flagged
  const shouldReveal = sessionStorage.getItem('page-transition-active');
  if (shouldReveal) {
    sessionStorage.removeItem('page-transition-active');
    requestAnimationFrame(() => {
      setTimeout(() => {
        overlay.classList.remove('hold');
        overlay.classList.add('slide-out');
        overlay.addEventListener('animationend', () => {
          overlay.classList.remove('slide-out');
          overlay.style.transform = '';
        }, { once: true });
      }, 500);
    });
  }

  // EXIT: intercept same-origin link clicks
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;

    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.hash) return;
    if (link.target === '_blank') return;
    if (link.hasAttribute('download')) return;
    if (e.ctrlKey || e.metaKey || e.shiftKey) return;

    e.preventDefault();
    sessionStorage.setItem('page-transition-active', '1');

    overlay.style.transform = '';
    overlay.classList.add('slide-in');

    overlay.addEventListener('animationend', () => {
      overlay.classList.remove('slide-in');
      overlay.classList.add('hold');
      setTimeout(() => {
        window.location.href = link.href;
      }, 350);
    }, { once: true });
  });
})();
